export default {
  catalog: 'Katalog',
  articles: 'Články',
  faq: 'FAQ',
};
